import { useState } from 'react';
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import Logo from "../../assets/images/logo-dark.png"
import { Link, useLocation } from 'react-router-dom';


export const Header = () => {
  const location = useLocation()
  let loginType: string | undefined | null = location.pathname.split('/')[1]
  if (!['odoo', "QBO", "xero", "zoho", "qbo"].includes(loginType)) {
    loginType = undefined
  }
  if (loginType === "qbo") {
    loginType = "QBO"
  }
  // Router state is lost on refresh / direct URL — default to login
  const from = location.state?.from ?? "login"
  const backTo = loginType ? `/${loginType}/${from}` : `/${from}`
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return <header className="header user_header">
    <div className='container'>
      <Navbar expand="md">
        <NavbarBrand href="/">
          <img
            alt="logo"
            src={Logo}
          />
        </NavbarBrand>
        {/* <NavbarToggler onClick={toggle} /> */}
        <Nav className="ml-auto" navbar>
          <NavItem>
            <NavLink tag={Link} to={backTo}>Go to {from}</NavLink>
          </NavItem>
        </Nav>
      </Navbar>
    </div>
  </header>
}
